import React from 'react';
import { Modal, Button } from 'antd';

export default function OrderCompleteConfirmModal({
  open,
  onCancel,
  onConfirmYes,
  onConfirmNo,
  order,
  loading,
}) {
  return (
    <Modal
      title="Complete order"
      open={!!open}
      onCancel={onCancel}
      footer={[
        <Button
          key="yes"
          type="primary"
          onClick={onConfirmYes}
          loading={loading}
          className="app-btn-primary"
        >
          Yes, send to completed
        </Button>,
        <Button
          key="no"
          onClick={onConfirmNo}
          loading={loading}
          className="app-btn-cancel"
        >
          No, keep as dispatch
        </Button>,
      ]}
      destroyOnClose
    >
      {order && (
        <>
          Are you sure you want to send this order to completed?
          {order.orderNumber && (
            <> (Order <strong>{order.orderNumber}</strong>)</>
          )}
        </>
      )}
    </Modal>
  );
}
